import axios from 'axios';
import { MAIN_URL, getApiHeaders } from "../Configurations/Urls";
import toast from 'react-hot-toast';


export const fetchOrganizations = async (client_id) => {
  try {
    const response = await axios.get(`${MAIN_URL}/api/organizations`, {
      params: { client_id },
      headers: getApiHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      toast.error("Session Expired!");
      window.location.href = "/login";
    }
    console.error("Error fetching organizations:", error);
    throw error;
  }
};